import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationServiceStatisticsGet = {
    path: "/template/service/statistics",
    method: ERouteHttpVerb.GET
};
export { routeLocationServiceStatisticsGet };
